$bog_smalljs_demo $mol_view
	guest \stranger
	sub /
		<= Name $mol_string
			hint @ \Type a name
			value? <=> name? \mol
		<= Greeting $mol_paragraph
			title <= greeting \Hello, mol!
